import request from '@/utils/request'

export function getSearchHistory(params) {
  return request({
    url: '/api/Index/QueryHistory',
    method: 'get',
    params
  })
}

export function getHotWords(params) {
  return request({
    url: '/api/Index/QueryWords',
    method: 'get',
    params
  })
}

export function getSearchResult(params) {
  return request({
    url: '/api/Index/QueryAll',
    method: 'get',
    params
  })
}
